import React from "react";
import Lp from "@components/templates/Lp";

export default function LpScreen() {
  return <Lp />;
}
